angular.module('shared').factory('WaiverValidationService', ["$q", function($q) {
  var invalidContactDetailsPosition, isPaymentDetailsFilled;
  invalidContactDetailsPosition = function(waiver) {
    var item;
    item = _.find(waiver.signed_waiver_contacts_attributes, function(contact) {
      var errors;
      errors = _.omit(contact.errors, 'membership_plan', 'membership_plan_name');
      return _.size(errors) > 0;
    });
    return item != null ? item.position : void 0;
  };
  isPaymentDetailsFilled = function(waiver, wallet) {
    return waiver.signed_waiver_form_attributes.payment_authority_active && (wallet.last4 && wallet.exp_month && wallet.exp_year && wallet.nameOnCard) || (wallet.bsb && wallet.accountNumber && wallet.accountName);
  };
  return {
    isPaymentDetailsInvalid: function(waiver, wallet) {
      var errors, ref, ref1, ref2, ref3, ref4;
      errors = waiver.errors;
      if ((ref = errors['signed_waiver_wallet_detail.privacy_policy_responses.accepted']) != null ? ref.length : void 0) {
        return true;
      }
      if (!waiver.signed_waiver_form_attributes.payment_authority_active) {
        return;
      }
      if (isPaymentDetailsFilled(waiver, wallet)) {
        return;
      }
      return ((ref1 = errors['signed_waiver_wallet_detail']) != null ? ref1.length : void 0) || ((ref2 = errors['signed_waiver_wallet_detail.full_name']) != null ? ref2.length : void 0) || ((ref3 = errors['signed_waiver_wallet_detail.last4']) != null ? ref3.length : void 0) || ((ref4 = errors['signed_waiver_wallet_detail.payment_method']) != null ? ref4.length : void 0);
    },
    isPaymentDetailsPresent: function(walletDetails) {
      return walletDetails.accountNumber || walletDetails.cardNumber || walletDetails.nameOnCard;
    },
    isGDPRInvalid: function(errors) {
      var ref;
      return (ref = errors['privacy_policy_responses.accepted']) != null ? ref.length : void 0;
    },
    getEmergencyContactDetailsErrors: function(waiver) {
      var details, fields, isRequired, response;
      details = waiver.signed_waiver_emergency_contact_detail_attributes;
      isRequired = waiver.signed_waiver_form_attributes.emergency_contact_details_required;
      if (isRequired && (!details.name || !details.relationship || !details.email || !details.phone_number || !details.address)) {
        response = {
          data: {
            errors: {}
          }
        };
        fields = ['name', 'relationship', 'email', 'phone_number', 'address'];
        fields.forEach(function(field) {
          if (!details[field]) {
            return response.data.errors[`signed_waiver_emergency_contact_detail.${field}`] = ['This field is required'];
          }
        });
        return response;
      } else {
        return false;
      }
    },
    getContactErrors: function(waiver) {
      var contacts, params, response, validatedContacts;
      params = {
        hasErrors: false
      };
      contacts = waiver.signed_waiver_contacts_attributes;
      response = {
        data: {
          errors: {}
        }
      };
      validatedContacts = contacts.map(function(contact) {
        var duplicates;
        duplicates = _.filter(contacts, function(c) {
          return contact.member_number && contact.member_number === c.member_number;
        });
        if (duplicates.length && contact.position !== duplicates[0].position) {
          params.hasErrors = true;
          contact.errors = {
            member_number: ['Must be unique']
          };
        } else {
          contact.errors = {};
        }
        return contact;
      });
      if (params.hasErrors) {
        waiver.signed_waiver_contacts_attributes = validatedContacts;
        return response;
      } else {
        return false;
      }
    },
    validateWaiver: function(waiver) {
      var deferred, details, errors, isRequired;
      deferred = $q.defer();
      details = waiver.signed_waiver_emergency_contact_detail_attributes;
      isRequired = waiver.signed_waiver_form_attributes.emergency_contact_details_required;
      errors = this.getEmergencyContactDetailsErrors(waiver) || this.getContactErrors(waiver);
      if (errors) {
        deferred.reject(errors);
      } else {
        deferred.resolve();
      }
      return deferred.promise;
    },
    hasEmergencyContactDetailErrors: function(errors) {
      var fields;
      fields = ['name', 'relationship', 'email', 'phone_number', 'address'];
      return !!_.find(fields, function(field) {
        var ref;
        return (ref = errors[`signed_waiver_emergency_contact_detail.${field}`]) != null ? ref.length : void 0;
      });
    },
    getInvalidFormName: function(waiver, wallet) {
      var errors, ref, ref1, ref2, ref3;
      errors = waiver.errors;
      switch (false) {
        case !(invalidContactDetailsPosition(waiver) >= 0):
          return `#contact_details_${invalidContactDetailsPosition(waiver)}`;
        case !(((ref = errors['signed_waiver_form.membership_plan']) != null ? ref.length : void 0) || ((ref1 = errors['signed_waiver_contacts.membership_plan']) != null ? ref1.length : void 0)):
          return '#membershipOptions';
        case !this.isPaymentDetailsInvalid(waiver, wallet):
          return '#walletDetails';
        case !((ref2 = errors['signed_waiver_form.signature']) != null ? ref2.length : void 0):
          return '#signatureField';
        case !((ref3 = errors['waiver_type']) != null ? ref3.length : void 0):
          return '#members_details';
        case !this.isGDPRInvalid(errors):
          return '#gdpr';
        case !this.hasEmergencyContactDetailErrors(errors):
          return '#emergency_contact';
        default:
          return void 0;
      }
    }
  };
}]);
